import {media} from "../../../dataSets/media";

export default function SubscriptionHeader() {
  return (
    <header className="subscriptionHeader">
        <h1 data-aos="fade-up">בנה, נהל ושגשג עם Webingo!</h1>
        <p className="subtitle" data-aos="fade-up">
            חסוך אלפי שקלים בשנה על בניית אתרים ותחזוקה - השליטה המלאה בידיים שלך.
        </p>
        <p data-aos="fade-up">
            ברוך הבא ל-Webingo, הפלטפורמה שמחברת אותך ישירות לקהל הלקוחות שלך, ללא צורך במפתחים, בעלויות תפעול גבוהות או בידע טכני. בחר את החבילה המתאימה ביותר לעסק שלך, והתחל לשלוט בנוכחות הדיגיטלית שלך עוד היום!
        </p>
        <img src={media.webingoLogo} alt="webingo-logo" className='webingo_logo'/>
    </header>
  )
}
